import React, { memo, useEffect, useState } from "react";
import Icon from "./Icons/Icon";
import "./LogInWithImage.scss";

function LogInWithImage(props) {
  const {
    doLogin,
    onChange,
    title,
    description,
    email,
    password,
    loginOptions,
    backgroundImage,
    brandLogo,
    brandLogoLeftPanel,
    welcomeLabel = "Welcome!",
    onShowPasswordChange,
    showPassword,
    rememberMe,
    onRememberMeChange,
    isCopyRightText = false,
    copyrightText = "",
    hideForgotPassword,
    forgotPassword,
    forgotPasswordView,
    sendPasswordLink,
    backgroundImageOverlayColor,
    backgroundImageOverlayColorOpacity,
    bottomTitle,
    bottomDescription = "",
    bottomDescription1 = "",
  } = props;
  const backgroundStyle = {};
  if (backgroundImage) {
    backgroundStyle.backgroundImage = `url(${backgroundImage})`;
  }
  const backgroundOverlayStyle = {
    backgroundColor: backgroundImageOverlayColor ? backgroundImageOverlayColor : "transparent",
    opacity: backgroundImageOverlayColorOpacity ? backgroundImageOverlayColorOpacity : 1,
    width: "100%",
    height: "100%",
  };

  const logo = brandLogo || "/img/logos/accenture-logo.svg";

  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const resetRedirecting = () => setRedirecting(false);
    window.addEventListener("pageshow", resetRedirecting);
    return () => window.removeEventListener("pageshow", resetRedirecting);
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      doLogin();
    }
  };

  const handleSsoClick = (e) => {
    if (redirecting) {
      e.preventDefault();
      return;
    }
    setRedirecting(true);
  };

  return (
    <div className="axiom-login-with-image">
      <div className="login-data-container">
        {brandLogoLeftPanel && (
          <div className="left-panel-login-brand-logo">
            <img src={logo} className="image-login-logo" />
          </div>
        )}
        <div className="image-login-header">{welcomeLabel}</div>
        <div className="image-login-content">
          {!forgotPasswordView && loginOptions && loginOptions.length > 0 && (
            <div className="image-login-sso">
              {loginOptions.map((option, index) => (
                <a
                  className={
                    redirecting
                      ? "image-login-sso-button image-login-sso-button-disabled"
                      : "image-login-sso-button"
                  }
                  href={option.uri}
                  key={index}
                  aria-disabled={redirecting}
                  onClick={handleSsoClick}
                >
                  {redirecting ? (
                    <>
                      <span className="image-login-sso-spinner" />
                      <span className="image-login-sso-label">Taking you to Microsoft...</span>
                    </>
                  ) : (
                    <>
                      {option.logo && <img className="image-login-sso-icon" src={option.logo} />}
                      <span className="image-login-sso-label">Sign in with Microsoft</span>
                    </>
                  )}
                </a>
              ))}
              <div className="image-login-sso-caption">Recommended for RR Kabel work accounts</div>
              <div className="image-login-divider">
                <span>OR</span>
              </div>
            </div>
          )}
          {forgotPasswordView ? (
            <>
              <div>
                <div className="image-login-label">Email ID</div>
                <div className="image-login-box">
                  <div className="image-login-input-logo">
                    <Icon icon={"ICON_USER"} className={"image-login-icon"} />
                  </div>
                  <div className="image-login-input-box">
                    <input
                      type={"text"}
                      className={"image-login-input"}
                      placeholder={""}
                      autoFocus={true}
                      onKeyPress={handleKeyPress}
                      onChange={(e) => onChange("email", e)}
                      value={email}
                    />
                  </div>
                </div>
              </div>
              <div className="image-login-btn" onClick={sendPasswordLink}>
                SUBMIT
              </div>
              <div className="login-form-forgot-password" onClick={forgotPassword}>
                LogIn
              </div>
            </>
          ) : (
            <div>
              <div>
                <label className="input-box-label">User Name</label>
                <div className="image-login-box">
                  <div className="image-login-input-logo">
                    <Icon icon={"ICON_USER"} className={"image-login-icon"} />
                  </div>
                  {/* Username */}
                  <div className="image-login-input-box">
                    <input
                      type={"text"}
                      className={"image-login-input"}
                      placeholder={"hello@example.com"}
                      autoFocus={true}
                      onKeyPress={handleKeyPress}
                      onChange={(e) => onChange("email", e)}
                      value={email}
                    />
                  </div>
                </div>
                <label className="input-box-label">Password</label>
                <div className="image-login-box">
                  <div className="image-login-input-logo">
                    <Icon icon={"ICON_PASSWORD"} className={"image-login-icon"} />
                  </div>
                  <div className="image-login-input-box">
                    <input
                      type={showPassword ? "text" : "password"}
                      className={"image-login-input"}
                      placeholder={"*******************"}
                      onKeyPress={handleKeyPress}
                      onChange={(e) => onChange("password", e)}
                    />
                    <label
                      className={"image-login-remember-me-label"}
                      onClick={(e) => onShowPasswordChange()}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </label>
                  </div>
                </div>
                <div className="image-login-rememberme">
                  <div className="checkbox-remember">
                    <input
                      type="checkbox"
                      className="image-login-rememberme-checkbox"
                      onChange={(e) => onRememberMeChange()}
                      defaultChecked={rememberMe}
                      id="image-login-rememberme-checkbox"
                    />
                    <label htmlFor="image-login-rememberme-checkbox"></label>
                    <label className={"image-rememberme-label"}>Remember me </label>
                  </div>
                  {!hideForgotPassword && (
                    <div className="login-form-forgot-password" onClick={forgotPassword}>
                      Forgot Password?
                    </div>
                  )}
                </div>
              </div>
              <div
                className={
                  redirecting ? "image-login-btn image-login-btn-disabled" : "image-login-btn"
                }
                onClick={redirecting ? undefined : doLogin}
              >
                LOG IN
              </div>
            </div>
          )}
        </div>
      </div>

      {isCopyRightText.toString() == "true" ? (
        <div className="copyright-login-bottom-container">{copyrightText}</div>
      ) : null}
      <div style={backgroundStyle} className="login-image-container">
        <div style={backgroundOverlayStyle}>
          <div className="login-brand-text">
            <div className="login-brand-title">{title}</div>
            <div className="login-brand-description">{description}</div>
          </div>
          {bottomTitle && (
            <div className="login-bottom-brand-text">
              <div className="login-brand-title">{bottomTitle}</div>
              <div className="login-bottom-brand-description">{bottomDescription}</div>
              <div className="login-bottom-brand-description">{bottomDescription1}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default memo(LogInWithImage);
